import { render, staticRenderFns } from "./PersonRemovedFromChatMessage.vue?vue&type=template&id=26f7c137&scoped=true&"
import script from "./PersonRemovedFromChatMessage.vue?vue&type=script&lang=ts&"
export * from "./PersonRemovedFromChatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./PersonRemovedFromChatMessage.vue?vue&type=style&index=0&id=26f7c137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f7c137",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
